import React, { useContext, useEffect, useState } from 'react'
import { Triangle } from 'react-loader-spinner'
import CustomDateBtn from '../../Component/CustomDateBtn'
import CustomLoader from '../../Component/CustomLoader'
import Dropbox from '../../Component/Dropbox'
import ListComp from '../../Component/ListComp'
import TopbarComp from '../../Component/TopbarComp'
import { useRequestData } from '../../hooks/RequestDataHook'
import { useLanguage } from '../../Providers/LanguageContext'
import HttpClient from '../../utils/HttpClient'
import revenue_edit1_en from "../../Audio_files/II. Revenue Manager Audio/II b. View & Edit Sales Revenue User Selected Option/ii_view_and_edit_sales_revenue_audio_a.mp3";
import revenue_edit1_es from "../../spanish_audio_files/II. Revenue Manager Audio/II b. View & Edit Sales Revenue User Selected Option/ii_view_and_edit_sales_revenue_audio_a_es.mp3";

import { SpeechContext } from '../../Providers/SpeechWrapper'
import { useLocation, useNavigate } from 'react-router-dom'
import { AiOutlineArrowLeft } from 'react-icons/ai'
import { useUserData } from '../../Providers/UserWrapper'
import { reactLocalStorage } from "reactjs-localstorage";

function TransactionDetails() {
  const { isInvestor, isBookKeeper } = useUserData();
  const { language, currentLanguage } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [isCleared, setIsCleared] = useState(false)
  const [transactionFilter, setTransactionsFilter] = useState({
    startDate: "",
    endDate: "",
    projectName: ""
  })
  const {
    currAudio, setCurrAudio, playing, setIsPlaying
  } = useContext(SpeechContext);

  // for dashboard
  const [hoverData, setHoverData] = useState({
    revenue: {},
    expense: {},
    revenueBudget: {},
    expenseBudget: {}
  })

  // Parse query parameters
  const searchParams = new URLSearchParams(location.search);
  const userCode = searchParams.get('id');

  console.log("searchParams: ", searchParams);
  

  // const { data,loading,error } = useRequestData("get-transaction", "POST", {
  //   startDate: "",
  //   endDate: "",
  //   projectName: ""
  // })

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false)

  console.log('locationGhhtrr', location.state)

  useEffect(() => {
    fetchProjects()
  }, [])

  useEffect(() => {
    setTransactionsFilter(prev => ({
      ...prev,
      startDate: location?.state?.startDate,
      endDate: location?.state?.endDate
    }))
  }, [location])

  const fetchProjects = async () => {
    const res = await HttpClient.requestData("projectname", "GET");
    console.log(res, "Resssss")
    if (res && res.status) {
      setProjects(res.data);
    } else {
      console.log("error fetching projects")
    }
  }



  const getStartDate = (value) => {
    setTransactionsFilter(prev => ({ ...prev, startDate: value }))
  }

  const getEndDate = (value) => {
    setTransactionsFilter(prev => ({ ...prev, endDate: value }))
  }

  const getProjectValue = (e) => {
    const val = e.target.value;
    if (val !== "Select project") {
      setTransactionsFilter(prev => ({ ...prev, projectName: val }))
    }
  }

  useEffect(() => {
    const { startDate, endDate, projectName } = transactionFilter;
    if (startDate && endDate) {
      fetchTransactions(transactionFilter)
    } else if (!startDate && !endDate && projectName) {
      fetchTransactions(transactionFilter)
    } else if (!startDate && !endDate && !projectName) {
      fetchTransactions(transactionFilter)
    }
  }, [transactionFilter])


  const fetchTransactions = async (filters) => {
    setLoading(true);
    // console.log("isInvestor: ", isInvestor);
    // console.log("isBookKeeper: ", isBookKeeper);
    // console.log("userCode: ", userCode);
    
    
    
    const res = await HttpClient.requestData(`sales-transaction/${isInvestor || isBookKeeper ? userCode : reactLocalStorage.getObject("userData")?.accountRegCode ? reactLocalStorage.getObject("userData")?.accountRegCode : ''}`, "GET");
    console.log('resGetTranbbh', res)
    setLoading(false)
    if (res && res.status) {
      setData(res.data);
    } else {
      console.log(res, "error")
    }
  }

  const clearFilters = () => {
    setTransactionsFilter({
      startDate: "",
      endDate: "",
      projectName: ""
    })
  }

  // gettinh hover data of dash board 2
  const getHoverData = async (time) => {
    const data = {
      "dayType": time
    }

    // revenue hover
    if (location?.state?.type === "revenue") {
      const res = await HttpClient.requestData("dashboard-two-hover-revenue", "POST", data);
      console.log("resddf", res)
      if (res && res?.status) {
        // setHoverData(prev => ({ ...prev, revenue: res?.data }));
        setTransactionsFilter((prev) => ({
          ...prev,
          startDate: res?.data?.startDate,
          endDate: res?.data?.endDate,
        }))
      } else {

      }
    }

    // // expense hover
    // const res1 = await HttpClient.requestData("dashboard-two-hover-expense", "POST", data);
    // console.log("tes1Exp", res1)
    // if (res1 && res1?.status) {
    //   setHoverData(prev => ({ ...prev, expense: res1?.data }))
    // } else {

    // }

    // revenue budget
    if (location?.state?.type === "revenue-budget") {
      const res2 = await HttpClient.requestData("dashboard-two-hover-revenue-budget", "POST", data);
      if (res2 && res2?.status) {
        // setHoverData(prev => ({ ...prev, revenueBudget: res2?.data }))
        setTransactionsFilter((prev) => ({
          ...prev,
          startDate: res2?.data?.startDate,
          endDate: res2?.data?.endDate,
        }))
      } else {

      }
    }

    // // expense budget
    // const res3 = await HttpClient.requestData("dashboard-two-hover-expense-budget", "POST", data);
    // if (res3 && res3?.status) {
    //   setHoverData(prev => ({ ...prev, expenseBudget: res3?.data }))
    // } else {

    // }
  }

  //for dashboard 2
  useEffect(() => {
    if (location?.state?.time) {
      getHoverData(location?.state?.time);
    }
  }, [location?.state?.time])

  useEffect(() => {
    console.log(currAudio, setCurrAudio, "funcsssss")
    if (playing) {
      if (currAudio) {
        if (!currAudio.paused) {
          currAudio.pause()
        }
      }
      if (currentLanguage === "eng") {
        setCurrAudio(new Audio(revenue_edit1_en))
      } else {
        setCurrAudio(new Audio(revenue_edit1_es))
      }
    } else {
      if (currAudio) {
        if (!currAudio.paused) {
          currAudio.pause()
          setCurrAudio(null)
        }
      }
    }

    return () => {
      if (currAudio && !currAudio.paused) {
        currAudio.pause()
      }
    }
  }, [playing, currentLanguage])

  // useEffect(() => {
  //   console.log("currAudio", currAudio)
  //   if (currAudio) {
  //     if (!currAudio.paused) {
  //       currAudio.pause()
  //     }
  //     currAudio.play()
  //   }
  //   return () => {
  //     if (currAudio && !currAudio.paused) {
  //       currAudio.pause()
  //     }
  //   }
  // }, [currAudio])
  useEffect(() => {
    window.scrollTo({ top: '0', behavior: 'instant' })
  }, [])


  return (
    <>
      <div style={{
        background: 'linear-gradient(rgba(15, 36, 55, 1), rgb(255, 255, 255))',
      }}>
        {/* <div className="try_fisibilty_wrapper " style={{
          transform: 'translateY(0%)',
          margin: '0px',
          justifyContent: 'start',
          background:'#031f31ff'

        }}>
          <div className="container-fluid">
            <p className="text-left">Revenue Manager / View Edit Revenue</p> </div>
        </div> */}
        <div className='container-fluid pt-3'>
          <div className='task_head'> Edit Existing Revenue </div>
        </div>
        <div className='container-fluid'>
          <div className='d-flex justify-content-start gap-3 align-items-center'>
            <div className='mt-3'>
              <button className=' d-flex justify-content-start align-items-center gap-2  slctUser' style={{
             
                fontWeight: '500',
                background: 'rgb(136, 233, 132)',
                color: '#0c2637'
              }} onClick={() => navigate('/postnewincome')}>
                <AiOutlineArrowLeft />
                {language.post_new_income}

              </button>
            </div>

          </div>
        </div>
        <div className='container-fluid transaction_details_wrapper_main' style={{
          marginTop: '15px'
        }}>


          <TopbarComp textprop={language.transaction_details} time={location?.state?.time} />
          <div className='d-flex justify-content-start gap-3 start_new_wrapper w-100'>
            <CustomDateBtn text={language.start_date} getValue={getStartDate} setIsCleared={setIsCleared} isCleared={isCleared} filters={{ date: transactionFilter?.startDate }} />
            <CustomDateBtn text={language.final_date} getValue={getEndDate} setIsCleared={setIsCleared} isCleared={isCleared} filters={{ date: transactionFilter?.endDate }} />
          </div>

          <Dropbox transactionFilter={transactionFilter} text={language.select_project} data={projects} getValue={getProjectValue} />
          {
            ((transactionFilter.startDate && transactionFilter.endDate) || (transactionFilter.projectName)) && (
              <div className='container'>
                <button className='customBtn3' onClick={clearFilters}>{language.clear_filters}</button>
              </div>
            )
          }

          {
            loading && (
              <CustomLoader />
            )
          }
          <ListComp transactions={data} transactionFilter={transactionFilter} />
        </div>
      </div>


    </>

  )
}


export default TransactionDetails